export default __webpack_public_path__ + "static/media/pickles_top.479ec4f8.png";